import { baseApi } from '@shared/api/baseApi'

export interface SetAutoRenewPayload {
  enabled: boolean
  payment_method_id?: number
}

export const setAutoRenew = async (payload: SetAutoRenewPayload): Promise<void> => {
  await baseApi.patch('/api/subscription/auto-renew', payload)
}
